export default "__VITE_ASSET__DuYP1N15__"